// extracted by mini-css-extract-plugin
export default {"section":"SorryPage_section__JQgE+"};